(function() {
	'use strict';

	/**
	 * @ngdoc service
	 * @name applicationParameters.service:ApplicationParametersService
	 * 
	 * @description
	 * 
	 */
	angular.module('applicationParameters').service(
			'ApplicationParametersService', ApplicationParametersService);

	function ApplicationParametersService(ApplicationParametersFactory,RemoteService) {

		var self = this;

		// store retrieved data
		var model = {
			appParamSearchReq : ApplicationParametersFactory
					.getAppParamSearchRequest(),
			adaptedAppParamSearchResult : null,
			appParamSaveReq : ApplicationParametersFactory
					.getAppParamSaveRequest()
		};

		self.getAppParamSearchRequest = function(searchCrieteria) {
			model.appParamSearchReq = ApplicationParametersFactory
					.getFormattedAppParamSearchRequest(searchCrieteria);
			return model.appParamSearchReq;
		};

		self.adaptAppParamMapList = function(appParamList) {
			model.adaptedAppParamSearchResult = ApplicationParametersFactory
					.adaptAppParamList(appParamList);
			return model.adaptedAppParamSearchResult;
		}
		
		self.saveAppParameters = function(saveAppParamList, successFn,
				errorFn) {
			model.appParamSaveReq = getSaveRequest(saveAppParamList);
			RemoteService.saveAppParams(model.appParamSaveReq).then(
					function(response) {
						successFn(response);
					}, function(error) {
						errorFn(error);
					});
		}

		function getSaveRequest(appParamList) {
			model.appParamSaveReq = ApplicationParametersFactory
					.getAppParamSaveRequest();
			if (!!appParamList) {
				setAppParameterListInSaveRequest(appParamList.generalAppParams);
				setAppParameterListInSaveRequest(appParamList.regulationAppParams);
				setAppParameterListInSaveRequest(appParamList.biddingAppParams);
				setAppParameterListInSaveRequest(appParamList.downLoadManagerAppParams);
				setAppParameterListInSaveRequest(appParamList.patternAppParams);
				model.appParamSaveReq.updateNow = appParamList.updateNow;
			} 
			return model.appParamSaveReq;
		}

		function setAppParameterListInSaveRequest(list) {
			if (!!list && list.length > 0) {
				for (var i = 0; i < list.length > 0; i++) {
					if (list[i].show) {
						model.appParamSaveReq.applicationParams
								.push(ApplicationParametersFactory
										.getFormattedAppParamSaveDTO(list[i]));
					}
				}
			}
		}
	}
})();